import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

	@Input() listaBanner:any[] = [];

  	constructor( private newRouter:Router ) { }

  	ngOnInit(): void {
  	}

  	fnIr( newItem ){
  		if( newItem.link ){
  			this.newRouter.navigate([newItem.link]);
  		}
  	}

}
